export const START_SPINNER = 'helpers/START_SPINNER'
export const STOP_SPINNER = 'helpers/STOP_SPINNER'
export const SET_REPORTING_DATES = 'helpers/SET_REPORTING_DATES'
export const SWITCH_INTERCOM = 'helpers/SWITCH_INTERCOM'
